import { render, staticRenderFns } from "./ClassAdviserDialog.vue?vue&type=template&id=696a4f4c&scoped=true"
import script from "./ClassAdviserDialog.vue?vue&type=script&lang=js"
export * from "./ClassAdviserDialog.vue?vue&type=script&lang=js"
import style0 from "./ClassAdviserDialog.vue?vue&type=style&index=0&id=696a4f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a4f4c",
  null
  
)

export default component.exports